import React,{useState} from 'react';
import {Container,Paper,TextField,Typography,Button,Box} from '@material-ui/core';
import MailIcon from '@material-ui/icons/Mail';
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import FacebookIcon from '@material-ui/icons/Facebook';
import FacebookLogin from 'react-facebook-login';
import {Link,useHistory} from 'react-router-dom';
import axios from 'axios';


import Message from '../message/Message';
import video from './WhatsApp Video 2021-07-28 at 5.07.56 PM.mp4';
import {useStyles} from './styles';



const Login = () => {
    const classes=useStyles();
    let history = useHistory();

    const [value,setValue]=useState(1);
    const [showMsg,setShowMsg]=useState(false);
    const [msg,setMsg]=useState("");
    const [color,setColor]=useState("green");
    const [showOtp,setShowOtp]=useState(false);
    const [verifyOtp,setVerifyOtp]=useState(false);
    const [sentOtp,setSentOtp]=useState(false);
    const [userInput,setUserInput]=useState({
        phone:'',
        otp:'',
        email:'',
        password:''
    })


    const responseFacebook = (response) => {
        axios.put("https://dream11-app-akshaya.herokuapp.com/api/login-fb",{fbID:response.userID}).then((res)=>{
          console.log("user",res);
          history.push("/home")
        //  sessionStorage.setItem("user",JSON.stringify(res.data.data));
        // navigateToHome()
        }).catch((error)=>{
            setMsg(error.response.data.message);
            setColor("red");
            setShowMsg(true)
        })
      }
      
    const sendOtp=async()=>{
        try{
            const res= await axios.post('https://dream11-app-akshaya.herokuapp.com/api/send-otp',{phoneNumber:userInput.phone})
            if(res.data.message==="Success"){
                setSentOtp(true);
                setMsg("Enter the otp sent to your mobile number");
                setColor("green")
                setShowMsg(true)
            }
          }
          catch(e){
              setMsg(e.response.data.message);
              setColor("red");
              setShowMsg(true)
          }
    }

    const handleRegister=async()=>{
        //if user enters phone number i.e if he chooses to go through phone , then make email fields null
        if(userInput.phone){
            setUserInput({...userInput,email:'',password:''})
            setShowOtp(true);
        }
        //if user didnt go through phone, then clear phone fields
        if(!userInput.phone){
            setUserInput({...userInput,phone:'',otp:''})
        }
        //if user chooses phone and didnt verify otp and didnt send otp, then make call to send otp api
        if(userInput.phone && !verifyOtp && !sentOtp){
            sendOtp();
        }
        //if user chooses through phone and sent otp but didnt verify otp , make api call to verify otp api
        if(userInput.phone && !verifyOtp && sentOtp && userInput.otp){
            try{
                const res= await axios.post('https://dream11-app-akshaya.herokuapp.com/api/verify-otp',{phoneNumber:userInput.phone,otp:userInput.otp})
                if(res.data.message==="Success"){
                    setVerifyOtp(true);
                    setSentOtp(false);
                    setShowOtp(false);
                    try{   //if otp is verified then signup through phone
                        const user=await axios.put('https://dream11-app-akshaya.herokuapp.com/api/login-phone',{phoneNumber:userInput.phone}
                    )
                     if(user){
                        setVerifyOtp(false);
                        console.log("signup wiith phone",user);
                        history.push("/home");
                     }
                    }
                    catch(e){
                        setMsg(e.response.data.message);
                        setColor("red");
                        setShowMsg(true)
                    }
                }
                else{
                    setMsg("Otp verification failed,try again");
                    setColor("red");
                    setShowMsg(true)
                }
              }
              catch(e){
                setMsg(e.response.data.message);
                setColor("red");
                setShowMsg(true)
              }
        }
        
       // console.log(userInput)
       //checking if email is valid
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        console.log(re.test(String(userInput.email).toLowerCase()))
        if(userInput.email && !re.test(String(userInput.email).toLowerCase())){
            console.log("invalid email")
            setMsg("Invalid email");
            setColor("red");
            setShowMsg(true)
           return;
        }
        //if user go through email then signup through email
        if(value===1 && userInput.email){
          try{
           const user=await axios.put('https://dream11-app-akshaya.herokuapp.com/api/login-username',{username:userInput.email,password:userInput.password})
           if(user){
            console.log("user is",user);
            history.push("/home");
           }
           else{
            setMsg("Login failed");
            setColor("red");
            setShowMsg(true)
           }
     
          }
          catch(e){
            setMsg(e.response.data.message);
            setColor("red");
            setShowMsg(true);
          }
        }
    }

    return (
       <Container maxWidth="lg" className={classes.root}>
           <Box component="div" className={classes.bgVideoCont}>
                    <video className={classes.bgVideo} autoPlay muted loop>
                        <source src={video} type="video/mp4"/>
                        <source src={video} type="video/webm"/>
                        Your browser is not supported!
                    </video>
                </Box>
           <Paper elevation={3} className={classes.paper}>
               <form className={classes.form}>
                  <Typography align="center" variant="h4" gutterBottom className={classes.title}>Sign In</Typography>
                  {
                      value===1? <Box component="div" display="flex" flexDirection="column" alignItems="center">
                      <TextField className={classes.input} value={userInput.email} onChange={(e)=>setUserInput({...userInput,email:e.target.value})}  type="text" label="Email" variant="outlined"/>
                      <TextField className={classes.input} value={userInput.password} onChange={(e)=>setUserInput({...userInput,password:e.target.value})} type="text" label="Password" variant="outlined"/>
                      </Box>:
                      <Box component="div" display="flex" flexDirection="column" alignItems="center">
                      {
                          !showOtp? <TextField className={classes.input} type="tel" value={userInput.phone} onChange={(e)=>setUserInput({...userInput,phone:e.target.value})} label="Phone Number" variant="outlined"/>:
                          <Box component="div" display="flex" flexDirection="column" alignItems="center" style={{width:'100%'}}>
                              <Typography variant="body2" align="center" gutterBottom>Enter the otp sent to your mobile number</Typography>
                              <TextField className={classes.input} type="tel" label="Otp"  value={userInput.otp} onChange={(e)=>setUserInput({...userInput,otp:e.target.value})} variant="outlined"/>
                          </Box>
                      }
                  </Box>
                  }
                <Box component="div" display="flex" justifyContent="center">
                   <Button variant="contained" color="secondary" className={classes.button} onClick={handleRegister}>
                    Continue
                    </Button>
                </Box>
               </form>
               <div className={classes.or}>or</div>
               <FacebookLogin 
             appId="1235183253569298"
             autoLoad={true}
             fields="name,email,picture"
             callback={responseFacebook}
             cssClass={classes.fbLogin}
             icon={<FacebookIcon style={{marginRight:'30px'}} />}
             textButton = "continue with facebook"/>
            {
                value===1?
            <Box component="div" onClick={()=>setValue(2)} className={classes.authOptions}>
                <PhoneAndroidIcon/> 
                <span>continue with phone</span>
           </Box> :
            <Box component="div" onClick={()=>setValue(1)} className={classes.authOptions}>
             <MailIcon/>
             <span>continue with email</span>
            </Box>
            }
             <Typography variant="body2" align="center">New to Dream11 Ipl ? <Link to="/register">Register</Link></Typography>
           </Paper>
           {showMsg?<Message color={color} message={msg} setShowMsg={setShowMsg}/>:null}
       </Container>
    )
}

export default Login
